import { type MCPServerInfo } from '../../types';

const GongCommunityServer: MCPServerInfo = {
  serverId: 'GONG_COMMUNITY',
  name: 'Gong (Community)',
  slug: 'gong-community',
  description:
    'Community Gong MCP server. List calls and retrieve transcripts using Gong API key credentials.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'mcp/gong:latest',
    commitSha: 'gong',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['gongAccessKey', 'gongAccessSecret'],
    properties: {
      gongAccessKey: {
        type: 'string',
        description: 'Gong Access Key',
        sensitive: true
      },
      gongAccessSecret: {
        type: 'string',
        description: 'Gong Access Secret',
        sensitive: true
      }
    }
  },
  deprecated: true
};

export default GongCommunityServer;
